var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.estado.label,
                                  id: _vm.formFields.estado.id,
                                  color: "yellow",
                                  readonly: _vm.isVerDetalle,
                                  hint: _vm.hint,
                                  "persistent-hint": true,
                                  "data-testid": _vm.testId + "--estado"
                                },
                                on: { change: _vm.cambio },
                                model: {
                                  value: _vm.estado,
                                  callback: function($$v) {
                                    _vm.estado = $$v
                                  },
                                  expression: "estado"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|numeric|excluded:0|max:10|codigoUnico",
                                    expression:
                                      "'required|numeric|excluded:0|max:10|codigoUnico'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.codigo.label,
                                  "data-vv-name": _vm.formFields.codigo.id,
                                  id: _vm.formFields.codigo.id,
                                  disabled: _vm.isVerDetalle || _vm.esEditar,
                                  counter: 10,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.codigo.id
                                  ),
                                  "data-testid": _vm.testId + "--codigo"
                                },
                                model: {
                                  value: _vm.formFields.codigo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.codigo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.codigo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "", sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80|NombreUnico",
                                    expression: "`required|max:80|NombreUnico`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  id: _vm.formFields.nombre.id,
                                  counter: "80",
                                  disabled: _vm.isVerDetalle,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-testid": _vm.testId + "--nombre"
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:200",
                                    expression: "'max:200'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.descripcion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.descripcion.id
                                  ),
                                  "data-vv-name": _vm.formFields.descripcion.id,
                                  counter: 200,
                                  disabled: _vm.isVerDetalle,
                                  "data-testid": _vm.testId + "--descripcion"
                                },
                                model: {
                                  value: _vm.formFields.descripcion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.descripcion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.descripcion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  items: _vm.tiposDispositivo,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.tipoDispositivoId.id
                                  ),
                                  label: _vm.formFields.tipoDispositivoId.label,
                                  "data-vv-name":
                                    _vm.formFields.tipoDispositivoId.id,
                                  "no-data-text": "Sin resultados",
                                  disabled: _vm.isVerDetalle,
                                  "item-text": "nombre",
                                  "item-value": "id",
                                  "data-testid":
                                    _vm.testId + "--tipoDispositivoId"
                                },
                                model: {
                                  value: _vm.formFields.tipoDispositivoId.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.tipoDispositivoId,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.tipoDispositivoId.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm6: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  items: _vm.gps,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.isGps.id
                                  ),
                                  label: _vm.formFields.isGps.label,
                                  "data-vv-name": _vm.formFields.isGps.id,
                                  disabled: _vm.isVerDetalle,
                                  "item-text": "nombre",
                                  "item-value": "valor",
                                  "data-testid": _vm.testId + "--isGps"
                                },
                                model: {
                                  value: _vm.formFields.isGps.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.isGps, "value", $$v)
                                  },
                                  expression: "formFields.isGps.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.iconoUrl !== ""
                            ? _c("v-flex", { attrs: { sm1: "", md1: "" } }, [
                                _vm.iconoUrl !== ""
                                  ? _c("img", {
                                      attrs: {
                                        src: _vm.iconoUrl,
                                        height: "50",
                                        alt: "Icono"
                                      }
                                    })
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                sm5: _vm.iconoUrl !== "",
                                sm6: _vm.iconoUrl == "",
                                md5: _vm.iconoUrl !== "",
                                md6: _vm.iconoUrl == ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Ícono",
                                  heigh: "",
                                  "prepend-icon": "attach_file",
                                  readonly: "readonly",
                                  disabled: _vm.isVerDetalle
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.image.click()
                                  }
                                },
                                model: {
                                  value: _vm.icono.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.icono, "name", $$v)
                                  },
                                  expression: "icono.name"
                                }
                              }),
                              _c("input", {
                                ref: "image",
                                staticStyle: { display: "none" },
                                attrs: {
                                  type: "file",
                                  accept: "image/png, image/jpeg",
                                  disabled: _vm.isVerDetalle
                                },
                                on: { change: _vm.onFilePicked }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: "Datos Extendidos",
                                  color: "yellow",
                                  readonly: _vm.isVerDetalle,
                                  "hide-details": ""
                                },
                                model: {
                                  value: _vm.mostrarDatos,
                                  callback: function($$v) {
                                    _vm.mostrarDatos = $$v
                                  },
                                  expression: "mostrarDatos"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-flex", {
                            attrs: { xs10: "", sm10: "", md10: "" }
                          }),
                          _vm.mostrarDatos
                            ? _c(
                                "v-flex",
                                { attrs: { xs2: "", sm2: "", md2: "" } },
                                [
                                  !_vm.isVerDetalle
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "icon",
                                          on: {
                                            click: function($event) {
                                              return _vm.handleCrearClick()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { dark: "", left: "" } },
                                            [_vm._v("add_circle_outline")]
                                          ),
                                          _c("span", [_vm._v("Agregar")])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.mostrarDatos
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md12: "" } },
                                [
                                  _c("MantenedorGrid", {
                                    attrs: { "grid-options": _vm.gridOptions }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ConfirmacionEliminar", {
        attrs: {
          show: _vm.isConfirmacionEliminarActivo,
          titulo: {
            entidad: "Dato Extendido",
            nombreEntidad: _vm.datoSeleccionado
              ? _vm.datoSeleccionado.nombre
              : ""
          },
          mensaje: { entidad: "el Dato Extendido" }
        },
        on: {
          aceptar: _vm.handleConfirmacionEliminar,
          cancelar: _vm.cerrarModalCrud
        }
      }),
      _vm.mostrarModalCrear
        ? _c("CrearTipoDatoExtendidoModal", {
            attrs: {
              datoExtendido: _vm.datoExtendido,
              dispositivoId: _vm.dispositivoId
            },
            on: {
              cerrar: _vm.handleCierraModalSinGuardar,
              cerrarBtnGuardar: function($event) {
                return _vm.handleCierreModalBtnGuardar($event)
              }
            }
          })
        : _vm._e(),
      _vm.mostrarModalEditar
        ? _c("EditarDatoExtendidoModal", {
            attrs: {
              datoSeleccionado: _vm.datoSeleccionado,
              datoExtendido: _vm.datoExtendido,
              dispositivoId: _vm.dispositivoId
            },
            on: {
              cerrar: _vm.handleCierraModalSinGuardar,
              cerrarBtnGuardar: function($event) {
                return _vm.handleCierreModalBtnGuardarEditar($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }